jQuery(document).ready(function($) {
    class ModalManager {
        constructor() {
            $('.modal').appendTo("body");
            $(document).on('click', () => this.closeModal());
        }

        closeModal() {
            $('.modal').modal('hide');
        }
    }

    class ImoveisFiltro {
        constructor() {
            this.elemento = document.getElementById("imoveisFiltro");
            this.botaoFechar = document.getElementById("fecharImoveisFiltro");
            this.limparButton = document.getElementById("limparButton");
            this.filterBox = document.getElementById("filterBox");

            if(this.elemento) {
                this.initEvents();
            }
        }

        initEvents() {
            this.filterBox.addEventListener("click", () => this.openFiltro());
            this.botaoFechar.addEventListener("click", () => this.closeFiltro());
            this.limparButton.addEventListener("click", () => this.limparSelecoes());
        }

        openFiltro() {
            if (window.innerWidth >= 1920) {
                this.elemento.style.right = "calc((100vw - 1332px) / 2)";
            } else {
                this.elemento.style.right = "0";
            }        
        }

        closeFiltro() {
            this.elemento.style.right = "-150%";
        }

        limparSelecoes() {
            const checkboxes = this.elemento.querySelectorAll("input[type='checkbox']");

            checkboxes.forEach((checkbox) => {
                checkbox.checked = false;
            });
        }
    }

    const modalManager = new ModalManager();
    const imoveisFiltro = new ImoveisFiltro();
});